import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import Layout from '@/views/layout'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          const { hzrouter } = await store.dispatch('user/getInfo')
          console.log(hzrouter, "permission");
          let routerList = []
          if (hzrouter.length === 0) return
          hzrouter.forEach(item => {
            item.children.forEach(citem => {
              let childrenList = []
              if (citem.children.length > 0 && !citem.URL.includes('Out')) {
                citem.children.forEach(ccitem => {
                  let cobj = {
                    path: '/' + ccitem.TAG_NAME,
                    name: ccitem.TAG_NAME,
                    meta: {
                      title: ccitem.NAME
                    },
                    component: resolve => require(['@/views' + ccitem.URL + '.vue'], resolve)
                    // component: () => import('@/views'+ccitem.URL)
                  }
                  childrenList.push(cobj)
                })
                routerList.push({
                  path: citem.URL,
                  name: citem.TAG_NAME,
                  component: Layout,
                  children: childrenList
                })
              }
            })
          })
          console.log(routerList)
          router.addRoutes(routerList)
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
